/**
* Created by bieao on 2020/4/1.
*/
<template>
  <div>
    <div class="item-position splitLine-top"></div>
    <img class="item-position logo-item" :src='
`/static/img/${isCj ? "CJ_logo":"logo"}.png`'/>
    <div v-if="!isCj" class="item-position project-name" :style="isCj ? 'left:250px':''">{{projectInfo.name}}</div>
    <div class="item-position project-status" :style="isCj ? 'left:250px':''">
      <div class="overview m-r-20">
        <div>配电箱总数：</div>
        <div>{{projectInfo.boxTotal}}</div>
      </div>
      <div class="overview m-r-20">
        <div>在线数：</div>
        <div>{{projectInfo.onlineTotal}}</div>
      </div>
      <div class="time-item m-r-20">
        <div class="m-r-10"><img src="/static/img/time.png"/></div>
        <div>{{time}}</div>
      </div>
      <div v-if="!!projectInfo.intro" class="dec-item">
        <div>项目简介：</div>
        <div>{{projectInfo.intro}}</div>
      </div>
    </div>
    <div class="item-position splitLine-bottom"></div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
const dateFormat = 'YYYY-MM-DD HH:mm:ss'
export default {
  name: 'Header',
  data () {
    return {
      time: dayjs().format(dateFormat),
      isCj: new URLSearchParams(window.location.href.split('?')[1]).get('userType') === 'bjcjjt'
    }
  },
  props: {
    projectInfo: {
      type: Object
    }
  },
  computed: {
  },
  methods: {
    showTime () {
      setInterval(() => {
        this.time = dayjs().format(dateFormat)
      }, 1000)
    }
  },
  created () {
    this.showTime()
  }
}
</script>

<style scoped lang="scss">
  .splitLine-top{
    left:0;
    top:20px;
    width:1800px;
    height:2px;
    background: url("/static/img/splitLine4.png") no-repeat;
    background-size: 100% 100%;
    filter: blur(1px);
  }
  .splitLine-bottom{
    left:0;
    top:120px;
    width:1400px;
    height:2px;
    background: url("/static/img/splitLine4.png") no-repeat;
    background-size: 100% 100%;
    filter: blur(1px);
  }
  .logo-item{
    left:20px;
    top:40px;
    height:60px;
  }
  .project-name{
    left: 120px;
    top: 38px;
    font-size: 35px;
    font-weight: 500;
  }
  .project-status{
    color:#5f7f9b;
    left: 120px;
    top: 90px;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    .overview {
      display: flex;
      align-items: center;
      div:nth-child(2) {
        color:#49d5f3;
      }
    }
    /*前端简介限制字数在50个以内*/
    .dec-item{
      display: flex;
      div:last-child{
        width: 700px;
        height: 19px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .time-item {
      display: flex;
      align-items: center;
      div:first-child{
        display: flex;
        align-items: center;
        img {
          width: 19px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue